export class PriceDto {
  public productID: number;
  public modifier: number;
  public priceLevel: number;
  public value: number;
}
